import { useEffect, useState } from "react";
import CanDataWrapper, { CanTableType } from "./CanDataWrapper";
import Space from "antd/es/space/index";

import moment from "moment";

import * as CanDataRutax from "../../commons/CanDataRutax";
import * as Common from "../../commons/common";
import * as TypeDTO from "../../commons/typeDTO";
import * as TypeUtils from "../../commons/typeUtils";

function CanDataRutaxViewer({
    loading,
    vehicleInfo,
    runningCanDataList,
    noFileteredCount,
    selectedDataPointIndex,
    onChangedSelectDataPointIndex,
    onMountedChart,
    onZoomed,
}: {
    loading: boolean;
    vehicleInfo?: TypeDTO.CarDto | undefined;
    runningCanDataList?: Array<TypeDTO.CanData> | undefined;
    noFileteredCount: number;
    selectedDataPointIndex?: number;
    onChangedSelectDataPointIndex?: (dataPointIndex: number) => void;
    onMountedChart?: () => void;
    onZoomed?: (zoom: any) => void;
}) {
    const [currentCanData, setCurrentCanData] = useState<CanDataRutax.CanData>();

    const convertRemarkWithUnit = (value: number | undefined, unit: string) => {
        return value !== undefined ? value.toFixed(2) + unit : "";
    };

    const convertRemarkOnOff = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                valueString = "Off";
                break;
            case 1:
                valueString = "On";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkFailure = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                valueString = "정상";
                break;
            case 1:
                valueString = "고장";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkNonActiveActive = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                valueString = "Non-Active";
                break;
            case 1:
                valueString = "Active";
                break;
            default:
                break;
        }
        return valueString;
    };

    const convertRemarkString = (value: number | undefined) => {
        if (value === undefined) return "";
        return String(value);
    };

    //#region EHBI_080H - Speed
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [ehbi080hPanelOpen, setEhbi080hPanelOpen] = useState(false);
    const [ehbi080hChartMounted, setEhbi080hChartMounted] = useState(false);
    const [selectedEhbi080h, setSelectedEhbi080h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasEhbi080h, setSeriesChartDatasEhbi080h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartEhbi080hSpeed, setChartEhbi080hSpeed] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_EHBI080H_SPEED_NAME,
        data: [],
    });

    const getTableTooltipEhbi080h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_EHBI080H_SPEED_KEY:
                return (
                    <>
                        <p>
                            EHBI_080H
                            <br />
                            CAN ID: 0x80
                            <br />
                            Name: EHBi_VS (Speed)
                        </p>
                        <p>Unit: km/h, Factor: 0.03125</p>
                    </>
                );
        }
        return null;
    };

    const getEhbi080hSpeedValue = () => {
        if (selectedEhbi080h.includes(Common.RUTAX_EHBI080H_SPEED_KEY) && currentCanData?.ehbi080h) {
            return convertRemarkWithUnit(currentCanData.ehbi080h.speed, Common.UNIT_SPEED);
        }
        return "";
    };

    const onChangeEhbi080h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedEhbi080h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasEhbi080h: Array<TypeUtils.ChartData> = [];

        if (selectedEhbi080h.includes(Common.RUTAX_EHBI080H_SPEED_KEY)) chartDatasEhbi080h.push(chartEhbi080hSpeed);

        setSeriesChartDatasEhbi080h(chartDatasEhbi080h);
    }, [selectedEhbi080h, chartEhbi080hSpeed]);

    const tableDataEhbi080h: CanTableType[] = [
        {
            key: Common.RUTAX_EHBI080H_SPEED_KEY,
            name: Common.RUTAX_EHBI080H_SPEED_NAME,
            value: getEhbi080hSpeedValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_090H - Brake
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu090hPanelOpen, setVcu090hPanelOpen] = useState(false);
    const [vcu090hChartMounted, setVcu090hChartMounted] = useState(false);
    const [selectedVcu090h, setSelectedVcu090h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu090h, setSeriesChartDatasVcu090h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu090hBrakingRequest, setChartVcu090hBrakingRequest] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU090H_BRAKING_REQ_NAME,
        data: [],
    });

    const getTableTooltipVcu090h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU090H_BRAKING_REQ_KEY:
                return (
                    <>
                        <p>
                            VCU_090H
                            <br />
                            CAN ID: 0x90
                            <br />
                            Name: vcu_BrakingRequest
                        </p>
                        <p>Unit: %, Factor: 0.125</p>
                    </>
                );
        }
        return null;
    };

    const getVcu090hBrakingRequestValue = () => {
        if (selectedVcu090h.includes(Common.RUTAX_VCU090H_BRAKING_REQ_KEY) && currentCanData?.vcu090h) {
            return convertRemarkWithUnit(currentCanData.vcu090h.brakingReq, Common.UNIT_PERCENT);
        }
        return "";
    };

    const onChangeVcu090h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu090h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu090h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu090h.includes(Common.RUTAX_VCU090H_BRAKING_REQ_KEY)) chartDatasVcu090h.push(chartVcu090hBrakingRequest);

        setSeriesChartDatasVcu090h(chartDatasVcu090h);
    }, [selectedVcu090h, chartVcu090hBrakingRequest]);

    const tableDataVcu090h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU090H_BRAKING_REQ_KEY,
            name: Common.RUTAX_VCU090H_BRAKING_REQ_NAME,
            value: getVcu090hBrakingRequestValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_1D5H - Torque
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu1d5hPanelOpen, setVcu1d5hPanelOpen] = useState(false);
    const [vcu1d5hChartMounted, setVcu1d5hChartMounted] = useState(false);
    const [selectedVcu1d5h, setSelectedVcu1d5h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu1d5h, setSeriesChartDatasVcu1d5h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu1d5hTorqueCmd, setChartVcu1d5hTorqueCmd] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU1D5H_TORQUE_CMD_NAME,
        data: [],
    });

    const getTableTooltipVcu1d5h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU1D5H_TORQUE_CMD_KEY:
                return (
                    <>
                        <p>
                            VCU_1D5H
                            <br />
                            CAN ID: 0x1D5
                            <br />
                            Name: TorqueCommand
                        </p>
                        <p>Unit: Nm, Factor: 0.0625, Offset: -2048</p>
                    </>
                );
        }
        return null;
    };

    const getVcu1d5hTorqueCmdValue = () => {
        if (selectedVcu1d5h.includes(Common.RUTAX_VCU1D5H_TORQUE_CMD_KEY) && currentCanData?.vcu1d5h) {
            return convertRemarkWithUnit(currentCanData.vcu1d5h.torqueCmd, Common.UNIT_TORQUE);
        }
        return "";
    };

    const onChangeVcu1d5h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu1d5h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu1d5h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu1d5h.includes(Common.RUTAX_VCU1D5H_TORQUE_CMD_KEY)) chartDatasVcu1d5h.push(chartVcu1d5hTorqueCmd);

        setSeriesChartDatasVcu1d5h(chartDatasVcu1d5h);
    }, [selectedVcu1d5h, chartVcu1d5hTorqueCmd]);

    const tableDataVcu1d5h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU1D5H_TORQUE_CMD_KEY,
            name: Common.RUTAX_VCU1D5H_TORQUE_CMD_NAME,
            value: getVcu1d5hTorqueCmdValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region BMS_1D9H - BMS
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [bms1d9hPanelOpen, setBms1d9hPanelOpen] = useState(false);
    const [bms1d9hChartMounted, setBms1d9hChartMounted] = useState(false);
    const [selectedBms1d9h, setSelectedBms1d9h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasBms1d9h, setSeriesChartDatasBms1d9h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartBms1d9hDcLinkVoltage, setChartBms1d9hDcLinkVoltage] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_BMS1D9H_DC_LINK_VOLT_NAME,
        data: [],
    });

    const [chartBms1d9hBatteryPackCurrent, setChartBms1d9hBatteryPackCurrent] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_BMS1D9H_BAT_PACK_CURR_NAME,
        data: [],
    });

    const getTableTooltipBms1d9h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_BMS1D9H_DC_LINK_VOLT_KEY:
                return (
                    <>
                        <p>
                            BMS_1D9H
                            <br />
                            CAN ID: 0x1D9
                            <br />
                            Name: BMS_DCLinkVoltage
                        </p>
                        <p>Unit: V, Factor: 0.1</p>
                    </>
                );

            case Common.RUTAX_BMS1D9H_BAT_PACK_CURR_KEY:
                return (
                    <>
                        <p>
                            BMS_1D9H
                            <br />
                            CAN ID: 0x1D9
                            <br />
                            Name: BMS_BatteryPackCurrent
                        </p>
                        <p>Unit: A, Factor: 0.1, Offset: -600</p>
                    </>
                );
        }
        return null;
    };

    const getBms1d9hDcLinkVoltageValue = () => {
        if (selectedBms1d9h.includes(Common.RUTAX_BMS1D9H_DC_LINK_VOLT_KEY) && currentCanData?.bms1d9h) {
            return convertRemarkWithUnit(currentCanData.bms1d9h.dcLinkVolt, Common.UNIT_VOLTAGE);
        }
        return "";
    };

    const getBms1d9hBatteryPackCurrentValue = () => {
        if (selectedBms1d9h.includes(Common.RUTAX_BMS1D9H_BAT_PACK_CURR_KEY) && currentCanData?.bms1d9h) {
            return convertRemarkWithUnit(currentCanData.bms1d9h.batPackCurr, Common.UNIT_CURRENT);
        }
        return "";
    };

    const onChangeBms1d9h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedBms1d9h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasBms1d9h: Array<TypeUtils.ChartData> = [];

        if (selectedBms1d9h.includes(Common.RUTAX_BMS1D9H_DC_LINK_VOLT_KEY)) chartDatasBms1d9h.push(chartBms1d9hDcLinkVoltage);
        if (selectedBms1d9h.includes(Common.RUTAX_BMS1D9H_BAT_PACK_CURR_KEY)) chartDatasBms1d9h.push(chartBms1d9hBatteryPackCurrent);

        setSeriesChartDatasBms1d9h(chartDatasBms1d9h);
    }, [selectedBms1d9h, chartBms1d9hDcLinkVoltage, chartBms1d9hBatteryPackCurrent]);

    const tableDataBms1d9h: CanTableType[] = [
        {
            key: Common.RUTAX_BMS1D9H_DC_LINK_VOLT_KEY,
            name: Common.RUTAX_BMS1D9H_DC_LINK_VOLT_NAME,
            value: getBms1d9hDcLinkVoltageValue(),
        },
        {
            key: Common.RUTAX_BMS1D9H_BAT_PACK_CURR_KEY,
            name: Common.RUTAX_BMS1D9H_BAT_PACK_CURR_NAME,
            value: getBms1d9hBatteryPackCurrentValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_321H - BMS SOC
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu321hPanelOpen, setVcu321hPanelOpen] = useState(false);
    const [vcu321hChartMounted, setVcu321hChartMounted] = useState(false);
    const [selectedVcu321h, setSelectedVcu321h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu321h, setSeriesChartDatasVcu321h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu321hBatteryPackRsoc, setChartVcu321hBatteryPackRsoc] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU321H_BAT_PACK_RSOC_NAME,
        data: [],
    });

    const getTableTooltipVcu321h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU321H_BAT_PACK_RSOC_KEY:
                return (
                    <>
                        <p>
                            VCU_321H
                            <br />
                            CAN ID: 0x321
                            <br />
                            Name: BMS_BatteryPackRSOC
                        </p>
                        <p>Unit: %, Factor: 0.1</p>
                    </>
                );
        }
        return null;
    };

    const getVcu321hBatteryPackRsocValue = () => {
        if (selectedVcu321h.includes(Common.RUTAX_VCU321H_BAT_PACK_RSOC_KEY) && currentCanData?.vcu321h) {
            return convertRemarkWithUnit(currentCanData.vcu321h.batPackRSoc, Common.UNIT_PERCENT);
        }
        return "";
    };

    const onChangeVcu321h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu321h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu321h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu321h.includes(Common.RUTAX_VCU321H_BAT_PACK_RSOC_KEY)) chartDatasVcu321h.push(chartVcu321hBatteryPackRsoc);

        setSeriesChartDatasVcu321h(chartDatasVcu321h);
    }, [selectedVcu321h, chartVcu321hBatteryPackRsoc]);

    const tableDataVcu321h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU321H_BAT_PACK_RSOC_KEY,
            name: Common.RUTAX_VCU321H_BAT_PACK_RSOC_NAME,
            value: getVcu321hBatteryPackRsocValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_323H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu323hPanelOpen, setVcu323hPanelOpen] = useState(false);
    const [vcu323hChartMounted, setVcu323hChartMounted] = useState(false);
    const [selectedVcu323h, setSelectedVcu323h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu323h, setSeriesChartDatasVcu323h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu323hBatteryMinTemp, setChartVcu323hBatteryMinTemp] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU323H_BAT_MIN_TEMP_NAME,
        data: [],
    });

    const [chartVcu323hBatteryMaxTemp, setChartVcu323hBatteryMaxTemp] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU323H_BAT_MAX_TEMP_NAME,
        data: [],
    });

    const getTableTooltipVcu323h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU323H_BAT_MIN_TEMP_KEY:
                return (
                    <>
                        <p>
                            VCU_323H
                            <br />
                            CAN ID: 0x323
                            <br />
                            Name: BMS_BatteryMinTemperature
                        </p>
                        <p>Unit: °C, Offset: -40</p>
                    </>
                );

            case Common.RUTAX_VCU323H_BAT_MAX_TEMP_KEY:
                return (
                    <>
                        <p>
                            VCU_323H
                            <br />
                            CAN ID: 0x323
                            <br />
                            Name: BMS_BatteryMaxTemperature
                        </p>
                        <p>Unit: °C, Offset: -40</p>
                    </>
                );
        }
        return null;
    };

    const getVcu323hBatteryMinTempValue = () => {
        if (selectedVcu323h.includes(Common.RUTAX_VCU323H_BAT_MIN_TEMP_KEY) && currentCanData?.vcu323h) {
            return convertRemarkWithUnit(currentCanData.vcu323h.batMinTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const getVcu323hBatteryMaxTempValue = () => {
        if (selectedVcu323h.includes(Common.RUTAX_VCU323H_BAT_MAX_TEMP_KEY) && currentCanData?.vcu323h) {
            return convertRemarkWithUnit(currentCanData.vcu323h.batMaxTemp, Common.UNIT_CELSIUS);
        }
        return "";
    };

    const onChangeVcu323h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu323h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu323h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu323h.includes(Common.RUTAX_VCU323H_BAT_MIN_TEMP_KEY)) chartDatasVcu323h.push(chartVcu323hBatteryMinTemp);
        if (selectedVcu323h.includes(Common.RUTAX_VCU323H_BAT_MAX_TEMP_KEY)) chartDatasVcu323h.push(chartVcu323hBatteryMaxTemp);

        setSeriesChartDatasVcu323h(chartDatasVcu323h);
    }, [selectedVcu323h, chartVcu323hBatteryMinTemp, chartVcu323hBatteryMaxTemp]);

    const tableDataVcu323h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU323H_BAT_MIN_TEMP_KEY,
            name: Common.RUTAX_VCU323H_BAT_MIN_TEMP_NAME,
            value: getVcu323hBatteryMinTempValue(),
        },
        {
            key: Common.RUTAX_VCU323H_BAT_MAX_TEMP_KEY,
            name: Common.RUTAX_VCU323H_BAT_MAX_TEMP_NAME,
            value: getVcu323hBatteryMaxTempValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_341H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu341hPanelOpen, setVcu341hPanelOpen] = useState(false);
    const [vcu341hChartMounted, setVcu341hChartMounted] = useState(false);
    const [selectedVcu341h, setSelectedVcu341h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu341h, setSeriesChartDatasVcu341h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu341hEvccPdStat, setChartVcu341hEvccPdStat] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU341H_PD_STAT_NAME,
        data: [],
    });

    const getTableTooltipVcu341h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU341H_PD_STAT_KEY:
                return (
                    <>
                        <p>
                            VCU_341H
                            <br />
                            CAN ID: 0x341
                            <br />
                            Name: EVCC_PDStat
                        </p>
                        <p>Remarks: 0=미연결, 1=연결, 2=충전중, 3=완료</p>
                    </>
                );
        }
        return null;
    };

    const convertVcu341hEvccPdStatRemark = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                return "Unplugged";
                break;
            case 1:
                return "Plug-in";
                break;
            case 2:
                return "S3 Open";
                break;
            default:
                break;;
        }
        return valueString;
    };

    const getVcu341hEvccPdStatValue = () => {
        if (selectedVcu341h.includes(Common.RUTAX_VCU341H_PD_STAT_KEY) && currentCanData?.vcu341h) {
            return convertVcu341hEvccPdStatRemark(currentCanData.vcu341h.pdStat);
        }
        return "";
    };

    const onChangeVcu341h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu341h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu341h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu341h.includes(Common.RUTAX_VCU341H_PD_STAT_KEY)) chartDatasVcu341h.push(chartVcu341hEvccPdStat);

        setSeriesChartDatasVcu341h(chartDatasVcu341h);
    }, [selectedVcu341h, chartVcu341hEvccPdStat]);

    const tableDataVcu341h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU341H_PD_STAT_KEY,
            name: Common.RUTAX_VCU341H_PD_STAT_NAME,
            value: getVcu341hEvccPdStatValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_343H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu343hPanelOpen, setVcu343hPanelOpen] = useState(false);
    const [vcu343hChartMounted, setVcu343hChartMounted] = useState(false);
    const [selectedVcu343h, setSelectedVcu343h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu343h, setSeriesChartDatasVcu343h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu343hChgFinished, setChartVcu343hChgFinished] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU343H_CHG_FINISHED_NAME,
        data: [],
    });

    const getTableTooltipVcu343h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU343H_CHG_FINISHED_KEY:
                return (
                    <>
                        <p>
                            VCU_343H
                            <br />
                            CAN ID: 0x343
                            <br />
                            Name: EVSE_EVCC_ChgFinished
                        </p>
                        <p>Remarks: 0=미완료, 1=완료</p>
                    </>
                );
        }
        return null;
    };

    const getVcu343hChgFinishedValue = () => {
        if (selectedVcu343h.includes(Common.RUTAX_VCU343H_CHG_FINISHED_KEY) && currentCanData?.vcu343h) {
            return currentCanData.vcu343h.chgFinished === 1 ? "완료" : "미완료";
        }
        return "";
    };

    const onChangeVcu343h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu343h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu343h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu343h.includes(Common.RUTAX_VCU343H_CHG_FINISHED_KEY)) chartDatasVcu343h.push(chartVcu343hChgFinished);

        setSeriesChartDatasVcu343h(chartDatasVcu343h);
    }, [selectedVcu343h, chartVcu343hChgFinished]);

    const tableDataVcu343h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU343H_CHG_FINISHED_KEY,
            name: Common.RUTAX_VCU343H_CHG_FINISHED_NAME,
            value: getVcu343hChgFinishedValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_7E7H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu7e7hPanelOpen, setVcu7e7hPanelOpen] = useState(false);
    const [vcu7e7hChartMounted, setVcu7e7hChartMounted] = useState(false);
    const [selectedVcu7e7h, setSelectedVcu7e7h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu7e7h, setSeriesChartDatasVcu7e7h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu7e7hCurrSteerAngle, setChartVcu7e7hCurrSteerAngle] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_NAME,
        data: [],
    });

    const [chartVcu7e7hRightLampStatus, setChartVcu7e7hRightLampStatus] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_NAME,
        data: [],
    });

    const [chartVcu7e7hLeftLampStatus, setChartVcu7e7hLeftLampStatus] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_NAME,
        data: [],
    });

    const [chartVcu7e7hHazardLampStatus, setChartVcu7e7hHazardLampStatus] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_NAME,
        data: [],
    });

    const [chartVcu7e7hEpbStatus, setChartVcu7e7hEpbStatus] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E7H_EPB_STATUS_NAME,
        data: [],
    });

    const getTableTooltipVcu7e7h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_KEY:
                return (
                    <>
                        <p>
                            VCU_7E7H
                            <br />
                            CAN ID: 0x7E7
                            <br />
                            Name: VCU_Curr_Steer_Angle
                        </p>
                        <p>Unit: °, Factor: -0.1</p>
                    </>
                );

            case Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_KEY:
            case Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_KEY:
            case Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_KEY:
            case Common.RUTAX_VCU7E7H_EPB_STATUS_KEY:
                return (
                    <>
                        <p>
                            VCU_7E7H
                            <br />
                            CAN ID: 0x7E7
                        </p>
                        <p>Remarks: 0=OFF, 1=ON</p>
                    </>
                );
        }
        return null;
    };

    const convertRemarkEpbStatus = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                valueString = "Released";
                break;
            case 1:
                valueString = "Locked";
                break;
            default:
                break;
        }
        return valueString;
    };

    const getVcu7e7hCurrSteerAngleValue = () => {
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_KEY) && currentCanData?.vcu7e7h) {
            return convertRemarkWithUnit(currentCanData.vcu7e7h.currSteerAngle, Common.UNIT_DEGREE);
        }
        return "";
    };

    const getVcu7e7hRightLampStatusValue = () => {
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_KEY) && currentCanData?.vcu7e7h) {
            return convertRemarkOnOff(currentCanData.vcu7e7h.rightLampStatus);
        }
        return "";
    };

    const getVcu7e7hLeftLampStatusValue = () => {
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_KEY) && currentCanData?.vcu7e7h) {
            return convertRemarkOnOff(currentCanData.vcu7e7h.leftLampStatus);
        }
        return "";
    };

    const getVcu7e7hHazardLampStatusValue = () => {
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_KEY) && currentCanData?.vcu7e7h) {
            return convertRemarkOnOff(currentCanData.vcu7e7h.hazardLampStatus);
        }
        return "";
    };

    const getVcu7e7hEpbStatusValue = () => {
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_EPB_STATUS_KEY) && currentCanData?.vcu7e7h) {
            return convertRemarkEpbStatus(currentCanData.vcu7e7h.epbStatus);
        }
        return "";
    };

    const onChangeVcu7e7h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu7e7h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu7e7h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_KEY)) chartDatasVcu7e7h.push(chartVcu7e7hCurrSteerAngle);
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_KEY)) chartDatasVcu7e7h.push(chartVcu7e7hRightLampStatus);
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_KEY)) chartDatasVcu7e7h.push(chartVcu7e7hLeftLampStatus);
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_KEY)) chartDatasVcu7e7h.push(chartVcu7e7hHazardLampStatus);
        if (selectedVcu7e7h.includes(Common.RUTAX_VCU7E7H_EPB_STATUS_KEY)) chartDatasVcu7e7h.push(chartVcu7e7hEpbStatus);

        setSeriesChartDatasVcu7e7h(chartDatasVcu7e7h);
    }, [
        selectedVcu7e7h,
        chartVcu7e7hCurrSteerAngle,
        chartVcu7e7hRightLampStatus,
        chartVcu7e7hLeftLampStatus,
        chartVcu7e7hHazardLampStatus,
        chartVcu7e7hEpbStatus,
    ]);

    const tableDataVcu7e7h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_KEY,
            name: Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_NAME,
            value: getVcu7e7hCurrSteerAngleValue(),
        },
        {
            key: Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_KEY,
            name: Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_NAME,
            value: getVcu7e7hRightLampStatusValue(),
        },
        {
            key: Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_KEY,
            name: Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_NAME,
            value: getVcu7e7hLeftLampStatusValue(),
        },
        {
            key: Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_KEY,
            name: Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_NAME,
            value: getVcu7e7hHazardLampStatusValue(),
        },
        {
            key: Common.RUTAX_VCU7E7H_EPB_STATUS_KEY,
            name: Common.RUTAX_VCU7E7H_EPB_STATUS_NAME,
            value: getVcu7e7hEpbStatusValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region VCU_7E8H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [vcu7e8hPanelOpen, setVcu7e8hPanelOpen] = useState(false);
    const [vcu7e8hChartMounted, setVcu7e8hChartMounted] = useState(false);
    const [selectedVcu7e8h, setSelectedVcu7e8h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasVcu7e8h, setSeriesChartDatasVcu7e8h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartVcu7e8hBmsFailure, setChartVcu7e8hBmsFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_BMS_FAIL_NAME,
        data: [],
    });

    const [chartVcu7e8hEpsFailure, setChartVcu7e8hEpsFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_EPS_FAIL_NAME,
        data: [],
    });

    const [chartVcu7e8hJoystickFailure, setChartVcu7e8hJoystickFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_JOYSTICK_FAIL_NAME,
        data: [],
    });

    const [chartVcu7e8hMcuFailure, setChartVcu7e8hMcuFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_MCU_FAIL_NAME,
        data: [],
    });

    const [chartVcu7e8hEscFailure, setChartVcu7e8hEscFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_ESC_FAIL_NAME,
        data: [],
    });

    const [chartVcu7e8hAdsFailure, setChartVcu7e8hAdsFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_ADS_FAIL_NAME,
        data: [],
    });

    const [chartVcu7e8hBcuFailure, setChartVcu7e8hBcuFailure] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_VCU7E8H_BCU_FAIL_NAME,
        data: [],
    });

    const getTableTooltipVcu7e8h = (key: React.Key) => {
        return (
            <>
                <p>
                    VCU_7E8H
                    <br />
                    CAN ID: 0x7E8
                </p>
                <p>Remarks: 0=정상, 1=고장</p>
            </>
        );
    };

    const getVcu7e8hBmsFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_BMS_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.bmsFail);
        }
        return "";
    };

    const getVcu7e8hEpsFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_EPS_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.epsFail);
        }
        return "";
    };

    const getVcu7e8hJoystickFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_JOYSTICK_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.joystickFail);
        }
        return "";
    };

    const getVcu7e8hMcuFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_MCU_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.mcuFail);
        }
        return "";
    };

    const getVcu7e8hEscFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_ESC_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.escFail);
        }
        return "";
    };

    const getVcu7e8hAdsFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_ADS_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.adsFail);
        }
        return "";
    };

    const getVcu7e8hBcuFailureValue = () => {
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_BCU_FAIL_KEY) && currentCanData?.vcu7e8h) {
            return convertRemarkFailure(currentCanData.vcu7e8h.bcuFail);
        }
        return "";
    };

    const onChangeVcu7e8h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedVcu7e8h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasVcu7e8h: Array<TypeUtils.ChartData> = [];

        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_BMS_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hBmsFailure);
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_EPS_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hEpsFailure);
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_JOYSTICK_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hJoystickFailure);
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_MCU_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hMcuFailure);
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_ESC_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hEscFailure);
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_ADS_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hAdsFailure);
        if (selectedVcu7e8h.includes(Common.RUTAX_VCU7E8H_BCU_FAIL_KEY)) chartDatasVcu7e8h.push(chartVcu7e8hBcuFailure);

        setSeriesChartDatasVcu7e8h(chartDatasVcu7e8h);
    }, [
        selectedVcu7e8h,
        chartVcu7e8hBmsFailure,
        chartVcu7e8hEpsFailure,
        chartVcu7e8hJoystickFailure,
        chartVcu7e8hMcuFailure,
        chartVcu7e8hEscFailure,
        chartVcu7e8hAdsFailure,
        chartVcu7e8hBcuFailure,
    ]);

    const tableDataVcu7e8h: CanTableType[] = [
        {
            key: Common.RUTAX_VCU7E8H_BMS_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_BMS_FAIL_NAME,
            value: getVcu7e8hBmsFailureValue(),
        },
        {
            key: Common.RUTAX_VCU7E8H_EPS_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_EPS_FAIL_NAME,
            value: getVcu7e8hEpsFailureValue(),
        },
        {
            key: Common.RUTAX_VCU7E8H_JOYSTICK_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_JOYSTICK_FAIL_NAME,
            value: getVcu7e8hJoystickFailureValue(),
        },
        {
            key: Common.RUTAX_VCU7E8H_MCU_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_MCU_FAIL_NAME,
            value: getVcu7e8hMcuFailureValue(),
        },
        {
            key: Common.RUTAX_VCU7E8H_ESC_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_ESC_FAIL_NAME,
            value: getVcu7e8hEscFailureValue(),
        },
        {
            key: Common.RUTAX_VCU7E8H_ADS_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_ADS_FAIL_NAME,
            value: getVcu7e8hAdsFailureValue(),
        },
        {
            key: Common.RUTAX_VCU7E8H_BCU_FAIL_KEY,
            name: Common.RUTAX_VCU7E8H_BCU_FAIL_NAME,
            value: getVcu7e8hBcuFailureValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region ADS_1B1H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [ads1b1hPanelOpen, setAds1b1hPanelOpen] = useState(false);
    const [ads1b1hChartMounted, setAds1b1hChartMounted] = useState(false);
    const [selectedAds1b1h, setSelectedAds1b1h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasAds1b1h, setSeriesChartDatasAds1b1h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartAds1b1hTargetSpeed, setChartAds1b1hTargetSpeed] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B1H_TARGET_SPEED_NAME,
        data: [],
    });

    const [chartAds1b1hAps, setChartAds1b1hAps] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B1H_APS_NAME,
        data: [],
    });

    const [chartAds1b1hGearStatusCmd, setChartAds1b1hGearStatusCmd] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B1H_GEAR_STATUS_CMD_NAME,
        data: [],
    });

    const [chartAds1b1hBrakingRequest, setChartAds1b1hBrakingRequest] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B1H_BRAKING_REQ_NAME,
        data: [],
    });

    const [chartAds1b1hAliveCounter, setChartAds1b1hAliveCounter] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B1H_ALIVE_COUNTER_NAME,
        data: [],
    });

    const getTableTooltipAds1b1h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_ADS1B1H_TARGET_SPEED_KEY:
                return (
                    <>
                        <p>
                            ADS_1B1H
                            <br />
                            CAN ID: 0x1B1
                            <br />
                            Name: ADS_Target_speed
                        </p>
                        <p>Unit: km/h, Factor: 0.01</p>
                    </>
                );
            case Common.RUTAX_ADS1B1H_APS_KEY:
                return (
                    <>
                        <p>
                            ADS_1B1H
                            <br />
                            CAN ID: 0x1B1
                            <br />
                            Name: ADS_APS
                        </p>
                        <p>Unit: %, Factor: 0.1</p>
                    </>
                );
            case Common.RUTAX_ADS1B1H_GEAR_STATUS_CMD_KEY:
                return (
                    <>
                        <p>
                            ADS_1B1H
                            <br />
                            CAN ID: 0x1B1
                            <br />
                            Name: ADS_GearStatusCmd
                        </p>
                        <p>Remarks: 0=N, 1=D, 2=R</p>
                    </>
                );
            case Common.RUTAX_ADS1B1H_BRAKING_REQ_KEY:
                return (
                    <>
                        <p>
                            ADS_1B1H
                            <br />
                            CAN ID: 0x1B1
                            <br />
                            Name: ADS_Braking_Request
                        </p>
                        <p>Unit: %, Factor: 0.125</p>
                    </>
                );
        }
        return null;
    };

    const getAds1b1hTargetSpeedValue = () => {
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_TARGET_SPEED_KEY) && currentCanData?.ads1b1h) {
            return convertRemarkWithUnit(currentCanData.ads1b1h.targetSpeed, Common.UNIT_SPEED);
        }
        return "";
    };

    const getAds1b1hApsValue = () => {
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_APS_KEY) && currentCanData?.ads1b1h) {
            return convertRemarkWithUnit(currentCanData.ads1b1h.aps, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getAds1b1hGearStatusCmdValue = () => {
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_GEAR_STATUS_CMD_KEY) && currentCanData?.ads1b1h) {
            return convertRemarkString(currentCanData.ads1b1h.gearStatusCmd);
        }
        return "";
    };

    const getAds1b1hBrakingRequestValue = () => {
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_BRAKING_REQ_KEY) && currentCanData?.ads1b1h) {
            return convertRemarkWithUnit(currentCanData.ads1b1h.brakingReq, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getAds1b1hAliveCounterValue = () => {
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_ALIVE_COUNTER_KEY) && currentCanData?.ads1b1h) {
            return String(currentCanData.ads1b1h.aliveCounter ?? "");
        }
        return "";
    };

    const onChangeAds1b1h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedAds1b1h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasAds1b1h: Array<TypeUtils.ChartData> = [];

        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_TARGET_SPEED_KEY)) chartDatasAds1b1h.push(chartAds1b1hTargetSpeed);
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_APS_KEY)) chartDatasAds1b1h.push(chartAds1b1hAps);
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_GEAR_STATUS_CMD_KEY)) chartDatasAds1b1h.push(chartAds1b1hGearStatusCmd);
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_BRAKING_REQ_KEY)) chartDatasAds1b1h.push(chartAds1b1hBrakingRequest);
        if (selectedAds1b1h.includes(Common.RUTAX_ADS1B1H_ALIVE_COUNTER_KEY)) chartDatasAds1b1h.push(chartAds1b1hAliveCounter);

        setSeriesChartDatasAds1b1h(chartDatasAds1b1h);
    }, [
        selectedAds1b1h,
        chartAds1b1hTargetSpeed,
        chartAds1b1hAps,
        chartAds1b1hGearStatusCmd,
        chartAds1b1hBrakingRequest,
        chartAds1b1hAliveCounter,
    ]);

    const tableDataAds1b1h: CanTableType[] = [
        {
            key: Common.RUTAX_ADS1B1H_TARGET_SPEED_KEY,
            name: Common.RUTAX_ADS1B1H_TARGET_SPEED_NAME,
            value: getAds1b1hTargetSpeedValue(),
        },
        {
            key: Common.RUTAX_ADS1B1H_APS_KEY,
            name: Common.RUTAX_ADS1B1H_APS_NAME,
            value: getAds1b1hApsValue(),
        },
        {
            key: Common.RUTAX_ADS1B1H_GEAR_STATUS_CMD_KEY,
            name: Common.RUTAX_ADS1B1H_GEAR_STATUS_CMD_NAME,
            value: getAds1b1hGearStatusCmdValue(),
        },
        {
            key: Common.RUTAX_ADS1B1H_BRAKING_REQ_KEY,
            name: Common.RUTAX_ADS1B1H_BRAKING_REQ_NAME,
            value: getAds1b1hBrakingRequestValue(),
        },
        {
            key: Common.RUTAX_ADS1B1H_ALIVE_COUNTER_KEY,
            name: Common.RUTAX_ADS1B1H_ALIVE_COUNTER_NAME,
            value: getAds1b1hAliveCounterValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region ADS_1B2H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [ads1b2hPanelOpen, setAds1b2hPanelOpen] = useState(false);
    const [ads1b2hChartMounted, setAds1b2hChartMounted] = useState(false);
    const [selectedAds1b2h, setSelectedAds1b2h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasAds1b2h, setSeriesChartDatasAds1b2h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartAds1b2hStatus, setChartAds1b2hStatus] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B2H_STATUS_NAME,
        data: [],
    });

    const [chartAds1b2hEpbRequest, setChartAds1b2hEpbRequest] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B2H_EPB_REQ_NAME,
        data: [],
    });

    const [chartAds1b2hEmergencyStop, setChartAds1b2hEmergencyStop] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B2H_EMERGENCY_STOP_REQ_NAME,
        data: [],
    });

    const [chartAds1b2hSteerAngle, setChartAds1b2hSteerAngle] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B2H_STEER_ANGLE_NAME,
        data: [],
    });

    const [chartAds1b2hAliveCounter, setChartAds1b2hAliveCounter] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B2H_ALIVE_COUNTER_NAME,
        data: [],
    });

    const getTableTooltipAds1b2h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_ADS1B2H_STATUS_KEY:
                return (
                    <>
                        <p>
                            ADS_1B2H
                            <br />
                            CAN ID: 0x1B2
                            <br />
                            Name: ADS_Status
                        </p>
                        <p>Remarks: 0=수동, 1=자율</p>
                    </>
                );
            case Common.RUTAX_ADS1B2H_STEER_ANGLE_KEY:
                return (
                    <>
                        <p>
                            ADS_1B2H
                            <br />
                            CAN ID: 0x1B2
                            <br />
                            Name: ADS_SteerAngle
                        </p>
                        <p>Unit: °, Factor: 0.1</p>
                    </>
                );
        }
        return null;
    };

    const getAds1b2hStatusValue = () => {
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_STATUS_KEY) && currentCanData?.ads1b2h) {
            return convertRemarkString(currentCanData.ads1b2h.status);
        }
        return "";
    };

    const getAds1b2hEpbRequestValue = () => {
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_EPB_REQ_KEY) && currentCanData?.ads1b2h) {
            return convertRemarkString(currentCanData.ads1b2h.epbReq);
        }
        return "";
    };

    const getAds1b2hEmergencyStopValue = () => {
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_EMERGENCY_STOP_REQ_KEY) && currentCanData?.ads1b2h) {
            return convertRemarkNonActiveActive(currentCanData.ads1b2h.emergencyStopReq);
        }
        return "";
    };

    const getAds1b2hSteerAngleValue = () => {
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_STEER_ANGLE_KEY) && currentCanData?.ads1b2h) {
            return convertRemarkWithUnit(currentCanData.ads1b2h.steerAngle, Common.UNIT_DEGREE);
        }
        return "";
    };

    const getAds1b2hAliveCounterValue = () => {
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_ALIVE_COUNTER_KEY) && currentCanData?.ads1b2h) {
            return convertRemarkString(currentCanData.ads1b2h.aliveCounter);
        }
        return "";
    };

    const onChangeAds1b2h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedAds1b2h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasAds1b2h: Array<TypeUtils.ChartData> = [];

        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_STATUS_KEY)) chartDatasAds1b2h.push(chartAds1b2hStatus);
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_EPB_REQ_KEY)) chartDatasAds1b2h.push(chartAds1b2hEpbRequest);
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_EMERGENCY_STOP_REQ_KEY)) chartDatasAds1b2h.push(chartAds1b2hEmergencyStop);
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_STEER_ANGLE_KEY)) chartDatasAds1b2h.push(chartAds1b2hSteerAngle);
        if (selectedAds1b2h.includes(Common.RUTAX_ADS1B2H_ALIVE_COUNTER_KEY)) chartDatasAds1b2h.push(chartAds1b2hAliveCounter);

        setSeriesChartDatasAds1b2h(chartDatasAds1b2h);
    }, [
        selectedAds1b2h,
        chartAds1b2hStatus,
        chartAds1b2hEpbRequest,
        chartAds1b2hEmergencyStop,
        chartAds1b2hSteerAngle,
        chartAds1b2hAliveCounter,
    ]);

    const tableDataAds1b2h: CanTableType[] = [
        {
            key: Common.RUTAX_ADS1B2H_STATUS_KEY,
            name: Common.RUTAX_ADS1B2H_STATUS_NAME,
            value: getAds1b2hStatusValue(),
        },
        {
            key: Common.RUTAX_ADS1B2H_EPB_REQ_KEY,
            name: Common.RUTAX_ADS1B2H_EPB_REQ_NAME,
            value: getAds1b2hEpbRequestValue(),
        },
        {
            key: Common.RUTAX_ADS1B2H_EMERGENCY_STOP_REQ_KEY,
            name: Common.RUTAX_ADS1B2H_EMERGENCY_STOP_REQ_NAME,
            value: getAds1b2hEmergencyStopValue(),
        },
        {
            key: Common.RUTAX_ADS1B2H_STEER_ANGLE_KEY,
            name: Common.RUTAX_ADS1B2H_STEER_ANGLE_NAME,
            value: getAds1b2hSteerAngleValue(),
        },
        {
            key: Common.RUTAX_ADS1B2H_ALIVE_COUNTER_KEY,
            name: Common.RUTAX_ADS1B2H_ALIVE_COUNTER_NAME,
            value: getAds1b2hAliveCounterValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region ADS_1B3H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [ads1b3hPanelOpen, setAds1b3hPanelOpen] = useState(false);
    const [ads1b3hChartMounted, setAds1b3hChartMounted] = useState(false);
    const [selectedAds1b3h, setSelectedAds1b3h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasAds1b3h, setSeriesChartDatasAds1b3h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartAds1b3hLampReqLh, setChartAds1b3hLampReqLh] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B3H_LAMP_REQ_LH_NAME,
        data: [],
    });

    const [chartAds1b3hLampReqRh, setChartAds1b3hLampReqRh] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B3H_LAMP_REQ_RH_NAME,
        data: [],
    });

    const [chartAds1b3hLampReqHazard, setChartAds1b3hLampReqHazard] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_NAME,
        data: [],
    });

    const getTableTooltipAds1b3h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_ADS1B3H_LAMP_REQ_LH_KEY:
            case Common.RUTAX_ADS1B3H_LAMP_REQ_RH_KEY:
            case Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_KEY:
                return (
                    <>
                        <p>
                            ADS_1B3H
                            <br />
                            CAN ID: 0x1B3
                        </p>
                        <p>Remarks: 0=OFF, 1=ON</p>
                    </>
                );
        }
        return null;
    };

    const convertAds1b3hLampReqRemark = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                valueString = "Non-Active";
                break;
            case 1:
                valueString = "Left";
                break;
            case 2:
                valueString = "Right";
                break;
            default:
                break;
        }
        return valueString;
    };

    const getAds1b3hLampReqLhValue = () => {
        if (selectedAds1b3h.includes(Common.RUTAX_ADS1B3H_LAMP_REQ_LH_KEY) && currentCanData?.ads1b3h) {
            return convertAds1b3hLampReqRemark(currentCanData.ads1b3h.lampReqLh);
        }
        return "";
    };

    const getAds1b3hLampReqRhValue = () => {
        if (selectedAds1b3h.includes(Common.RUTAX_ADS1B3H_LAMP_REQ_RH_KEY) && currentCanData?.ads1b3h) {
            return convertAds1b3hLampReqRemark(currentCanData.ads1b3h.lampReqRh);
        }
        return "";
    };

    const getAds1b3hLampReqHazardValue = () => {
        if (selectedAds1b3h.includes(Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_KEY) && currentCanData?.ads1b3h) {
            return convertRemarkNonActiveActive(currentCanData.ads1b3h.lampReqHazard);
        }
        return "";
    };

    const onChangeAds1b3h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedAds1b3h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasAds1b3h: Array<TypeUtils.ChartData> = [];

        if (selectedAds1b3h.includes(Common.RUTAX_ADS1B3H_LAMP_REQ_LH_KEY)) chartDatasAds1b3h.push(chartAds1b3hLampReqLh);
        if (selectedAds1b3h.includes(Common.RUTAX_ADS1B3H_LAMP_REQ_RH_KEY)) chartDatasAds1b3h.push(chartAds1b3hLampReqRh);
        if (selectedAds1b3h.includes(Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_KEY)) chartDatasAds1b3h.push(chartAds1b3hLampReqHazard);

        setSeriesChartDatasAds1b3h(chartDatasAds1b3h);
    }, [
        selectedAds1b3h,
        chartAds1b3hLampReqLh,
        chartAds1b3hLampReqRh,
        chartAds1b3hLampReqHazard,
    ]);

    const tableDataAds1b3h: CanTableType[] = [
        {
            key: Common.RUTAX_ADS1B3H_LAMP_REQ_LH_KEY,
            name: Common.RUTAX_ADS1B3H_LAMP_REQ_LH_NAME,
            value: getAds1b3hLampReqLhValue(),
        },
        {
            key: Common.RUTAX_ADS1B3H_LAMP_REQ_RH_KEY,
            name: Common.RUTAX_ADS1B3H_LAMP_REQ_RH_NAME,
            value: getAds1b3hLampReqRhValue(),
        },
        {
            key: Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_KEY,
            name: Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_NAME,
            value: getAds1b3hLampReqHazardValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region JOY_181H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [joy181hPanelOpen, setJoy181hPanelOpen] = useState(false);
    const [joy181hChartMounted, setJoy181hChartMounted] = useState(false);
    const [selectedJoy181h, setSelectedJoy181h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasJoy181h, setSeriesChartDatasJoy181h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartJoy181hDesiredSteerAngle, setChartJoy181hDesiredSteerAngle] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_NAME,
        data: [],
    });

    const [chartJoy181hEpbRequest, setChartJoy181hEpbRequest] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY181H_EPB_REQ_NAME,
        data: [],
    });

    const [chartJoy181hHazardLamp, setChartJoy181hHazardLamp] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY181H_HAZARD_LAMP_NAME,
        data: [],
    });

    const [chartJoy181hKeyoff, setChartJoy181hKeyoff] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY181H_KEYOFF_NAME,
        data: [],
    });

    const [chartJoy181hCounter, setChartJoy181hCounter] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY181H_ALIVE_COUNTER_NAME,
        data: [],
    });

    const getTableTooltipJoy181h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_KEY:
                return (
                    <>
                        <p>
                            JOY_181H
                            <br />
                            CAN ID: 0x181
                            <br />
                            Name: joy_desired_steer_angle
                        </p>
                        <p>Unit: °, Factor: 0.1</p>
                    </>
                );
        }
        return null;
    };

    const convertRemarkJoyEpbRequest = (value: number | undefined) => {
        let valueString = "Unknown";
        switch (value) {
            case 0:
                valueString = "No";
                break;
            case 1:
                valueString = "Unlock";
                break;
            case 2:
                valueString = "Lock";
                break;
            case 3:
                valueString = "Reserved";
                break;
            default:
                break;
        }
        return valueString;
    };

    const getJoy181hDesiredSteerAngleValue = () => {
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_KEY) && currentCanData?.joy181h) {
            return convertRemarkWithUnit(currentCanData.joy181h.desiredSteerAngle, Common.UNIT_DEGREE);
        }
        return "";
    };

    const getJoy181hEpbRequestValue = () => {
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_EPB_REQ_KEY) && currentCanData?.joy181h) {
            return convertRemarkJoyEpbRequest(currentCanData.joy181h.epbReq);
        }
        return "";
    };

    const getJoy181hHazardLampValue = () => {
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_HAZARD_LAMP_KEY) && currentCanData?.joy181h) {
            return convertRemarkOnOff(currentCanData.joy181h.hazardLamp);
        }
        return "";
    };

    const getJoy181hKeyoffValue = () => {
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_KEYOFF_KEY) && currentCanData?.joy181h) {
            return convertRemarkOnOff(currentCanData.joy181h.keyoff);
        }
        return "";
    };

    const getJoy181hCounterValue = () => {
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_ALIVE_COUNTER_KEY) && currentCanData?.joy181h) {
            return convertRemarkString(currentCanData.joy181h.aliveCounter);
        }
        return "";
    };

    const onChangeJoy181h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedJoy181h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasJoy181h: Array<TypeUtils.ChartData> = [];

        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_KEY)) chartDatasJoy181h.push(chartJoy181hDesiredSteerAngle);
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_EPB_REQ_KEY)) chartDatasJoy181h.push(chartJoy181hEpbRequest);
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_HAZARD_LAMP_KEY)) chartDatasJoy181h.push(chartJoy181hHazardLamp);
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_KEYOFF_KEY)) chartDatasJoy181h.push(chartJoy181hKeyoff);
        if (selectedJoy181h.includes(Common.RUTAX_JOY181H_ALIVE_COUNTER_KEY)) chartDatasJoy181h.push(chartJoy181hCounter);

        setSeriesChartDatasJoy181h(chartDatasJoy181h);
    }, [
        selectedJoy181h,
        chartJoy181hDesiredSteerAngle,
        chartJoy181hEpbRequest,
        chartJoy181hHazardLamp,
        chartJoy181hKeyoff,
        chartJoy181hCounter,
    ]);

    const tableDataJoy181h: CanTableType[] = [
        {
            key: Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_KEY,
            name: Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_NAME,
            value: getJoy181hDesiredSteerAngleValue(),
        },
        {
            key: Common.RUTAX_JOY181H_EPB_REQ_KEY,
            name: Common.RUTAX_JOY181H_EPB_REQ_NAME,
            value: getJoy181hEpbRequestValue(),
        },
        {
            key: Common.RUTAX_JOY181H_HAZARD_LAMP_KEY,
            name: Common.RUTAX_JOY181H_HAZARD_LAMP_NAME,
            value: getJoy181hHazardLampValue(),
        },
        {
            key: Common.RUTAX_JOY181H_KEYOFF_KEY,
            name: Common.RUTAX_JOY181H_KEYOFF_NAME,
            value: getJoy181hKeyoffValue(),
        },
        {
            key: Common.RUTAX_JOY181H_ALIVE_COUNTER_KEY,
            name: Common.RUTAX_JOY181H_ALIVE_COUNTER_NAME,
            value: getJoy181hCounterValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region JOY_182H
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const [joy182hPanelOpen, setJoy182hPanelOpen] = useState(false);
    const [joy182hChartMounted, setJoy182hChartMounted] = useState(false);
    const [selectedJoy182h, setSelectedJoy182h] = useState<Array<React.Key>>([]);
    const [seriesChartDatasJoy182h, setSeriesChartDatasJoy182h] = useState<Array<TypeUtils.ChartData>>([]);

    const [chartJoy182hMcuRpmSet, setChartJoy182hMcuRpmSet] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY182H_MCU_RPM_SET_NAME,
        data: [],
    });

    const [chartJoy182hDirection, setChartJoy182hDirection] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY182H_DIRECTION_NAME,
        data: [],
    });

    const [chartJoy182hBrakingRequest, setChartJoy182hBrakingRequest] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY182H_BRAKING_REQ_NAME,
        data: [],
    });

    const [chartJoy182hCounter, setChartJoy182hCounter] = useState<TypeUtils.ChartData>({
        name: Common.RUTAX_JOY182H_ALIVE_COUNTER_NAME,
        data: [],
    });

    const getTableTooltipJoy182h = (key: React.Key) => {
        switch (key) {
            case Common.RUTAX_JOY182H_DIRECTION_KEY:
                return (
                    <>
                        <p>
                            JOY_182H
                            <br />
                            CAN ID: 0x182
                            <br />
                            Name: joy_direction
                        </p>
                        <p>Remarks: 0=N, 1=D, 2=R</p>
                    </>
                );
            case Common.RUTAX_JOY182H_BRAKING_REQ_KEY:
                return (
                    <>
                        <p>
                            JOY_182H
                            <br />
                            CAN ID: 0x182
                            <br />
                            Name: joy_braking_request
                        </p>
                        <p>Unit: %, Factor: 0.002</p>
                    </>
                );
        }
        return null;
    };

    const getJoy182hMcuRpmSetValue = () => {
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_MCU_RPM_SET_KEY) && currentCanData?.joy182h) {
            return convertRemarkString(currentCanData.joy182h.mcuRpmSet);
        }
        return "";
    };

    const getJoy182hDirectionValue = () => {
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_DIRECTION_KEY) && currentCanData?.joy182h) {
            return convertRemarkString(currentCanData.joy182h.direction);
        }
        return "";
    };

    const getJoy182hBrakingRequestValue = () => {
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_BRAKING_REQ_KEY) && currentCanData?.joy182h) {
            return convertRemarkWithUnit(currentCanData.joy182h.brakingReq, Common.UNIT_PERCENT);
        }
        return "";
    };

    const getJoy182hCounterValue = () => {
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_ALIVE_COUNTER_KEY) && currentCanData?.joy182h) {
            return convertRemarkString(currentCanData.joy182h.aliveCounter);
        }
        return "";
    };

    const onChangeJoy182h = (selectedRowKeys: React.Key[], selectedRows: CanTableType[]) => {
        setSelectedJoy182h(selectedRowKeys);
    };

    useEffect(() => {
        const chartDatasJoy182h: Array<TypeUtils.ChartData> = [];

        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_MCU_RPM_SET_KEY)) chartDatasJoy182h.push(chartJoy182hMcuRpmSet);
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_DIRECTION_KEY)) chartDatasJoy182h.push(chartJoy182hDirection);
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_BRAKING_REQ_KEY)) chartDatasJoy182h.push(chartJoy182hBrakingRequest);
        if (selectedJoy182h.includes(Common.RUTAX_JOY182H_ALIVE_COUNTER_KEY)) chartDatasJoy182h.push(chartJoy182hCounter);

        setSeriesChartDatasJoy182h(chartDatasJoy182h);
    }, [
        selectedJoy182h,
        chartJoy182hMcuRpmSet,
        chartJoy182hDirection,
        chartJoy182hBrakingRequest,
        chartJoy182hCounter,
    ]);

    const tableDataJoy182h: CanTableType[] = [
        {
            key: Common.RUTAX_JOY182H_MCU_RPM_SET_KEY,
            name: Common.RUTAX_JOY182H_MCU_RPM_SET_NAME,
            value: getJoy182hMcuRpmSetValue(),
        },
        {
            key: Common.RUTAX_JOY182H_DIRECTION_KEY,
            name: Common.RUTAX_JOY182H_DIRECTION_NAME,
            value: getJoy182hDirectionValue(),
        },
        {
            key: Common.RUTAX_JOY182H_BRAKING_REQ_KEY,
            name: Common.RUTAX_JOY182H_BRAKING_REQ_NAME,
            value: getJoy182hBrakingRequestValue(),
        },
        {
            key: Common.RUTAX_JOY182H_ALIVE_COUNTER_KEY,
            name: Common.RUTAX_JOY182H_ALIVE_COUNTER_NAME,
            value: getJoy182hCounterValue(),
        },
    ];
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    //#endregion

    //#region Data Processing
    useEffect(() => {
        if (vehicleInfo?.makerModel?.maker?.makerName !== Common.VehicleMaker.Emotion) return;
        if (!runningCanDataList || runningCanDataList.length === 0) return;

        // EHBI_080H
        const ehbi080hSpeedData: Array<TypeUtils.ChartElement> = [];
        // VCU_090H
        const vcu090hBrakingRequestData: Array<TypeUtils.ChartElement> = [];
        // VCU_1D5H
        const vcu1d5hTorqueCommandData: Array<TypeUtils.ChartElement> = [];
        // BMS_1D9H
        const bms1d9hDcLinkVoltageData: Array<TypeUtils.ChartElement> = [];
        const bms1d9hBatteryPackCurrentData: Array<TypeUtils.ChartElement> = [];
        // VCU_321H
        const vcu321hBatteryPackRsocData: Array<TypeUtils.ChartElement> = [];
        // VCU_323H
        const vcu323hBatteryMinTempData: Array<TypeUtils.ChartElement> = [];
        const vcu323hBatteryMaxTempData: Array<TypeUtils.ChartElement> = [];
        // VCU_341H
        const vcu341hEvccPdStatData: Array<TypeUtils.ChartElement> = [];
        // VCU_343H
        const vcu343hChgFinishedData: Array<TypeUtils.ChartElement> = [];
        // VCU_7E7H
        const vcu7e7hCurrSteerAngleData: Array<TypeUtils.ChartElement> = [];
        const vcu7e7hRightLampStatusData: Array<TypeUtils.ChartElement> = [];
        const vcu7e7hLeftLampStatusData: Array<TypeUtils.ChartElement> = [];
        const vcu7e7hHazardLampStatusData: Array<TypeUtils.ChartElement> = [];
        const vcu7e7hEpbStatusData: Array<TypeUtils.ChartElement> = [];
        // VCU_7E8H
        const vcu7e8hBmsFailureData: Array<TypeUtils.ChartElement> = [];
        const vcu7e8hEpsFailureData: Array<TypeUtils.ChartElement> = [];
        const vcu7e8hJoystickFailureData: Array<TypeUtils.ChartElement> = [];
        const vcu7e8hMcuFailureData: Array<TypeUtils.ChartElement> = [];
        const vcu7e8hEscFailureData: Array<TypeUtils.ChartElement> = [];
        const vcu7e8hAdsFailureData: Array<TypeUtils.ChartElement> = [];
        const vcu7e8hBcuFailureData: Array<TypeUtils.ChartElement> = [];
        // ADS_1B1H
        const ads1b1hTargetSpeedData: Array<TypeUtils.ChartElement> = [];
        const ads1b1hApsData: Array<TypeUtils.ChartElement> = [];
        const ads1b1hGearStatusCmdData: Array<TypeUtils.ChartElement> = [];
        const ads1b1hBrakingRequestData: Array<TypeUtils.ChartElement> = [];
        const ads1b1hAliveCounterData: Array<TypeUtils.ChartElement> = [];
        // ADS_1B2H
        const ads1b2hStatusData: Array<TypeUtils.ChartElement> = [];
        const ads1b2hEpbRequestData: Array<TypeUtils.ChartElement> = [];
        const ads1b2hEmergencyStopData: Array<TypeUtils.ChartElement> = [];
        const ads1b2hSteerAngleData: Array<TypeUtils.ChartElement> = [];
        const ads1b2hAliveCounterData: Array<TypeUtils.ChartElement> = [];
        // ADS_1B3H
        const ads1b3hLampReqLhData: Array<TypeUtils.ChartElement> = [];
        const ads1b3hLampReqRhData: Array<TypeUtils.ChartElement> = [];
        const ads1b3hLampReqHazardData: Array<TypeUtils.ChartElement> = [];
        // JOY_181H
        const joy181hDesiredSteerAngleData: Array<TypeUtils.ChartElement> = [];
        const joy181hEpbRequestData: Array<TypeUtils.ChartElement> = [];
        const joy181hHazardLampData: Array<TypeUtils.ChartElement> = [];
        const joy181hKeyoffData: Array<TypeUtils.ChartElement> = [];
        const joy181hCounterData: Array<TypeUtils.ChartElement> = [];
        // JOY_182H
        const joy182hMcuRpmSetData: Array<TypeUtils.ChartElement> = [];
        const joy182hDirectionData: Array<TypeUtils.ChartElement> = [];
        const joy182hBrakingRequestData: Array<TypeUtils.ChartElement> = [];
        const joy182hCounterData: Array<TypeUtils.ChartElement> = [];

        runningCanDataList.forEach((canData) => {
            const rutaxData = canData as CanDataRutax.CanData;
            const dataTime = moment(rutaxData.dataTime).valueOf();

            // EHBI_080H
            if (rutaxData.ehbi080h) {
                ehbi080hSpeedData.push({ x: dataTime, y: rutaxData.ehbi080h.speed });
            }
            // VCU_090H
            if (rutaxData.vcu090h) {
                vcu090hBrakingRequestData.push({ x: dataTime, y: rutaxData.vcu090h.brakingReq });
            }
            // VCU_1D5H
            if (rutaxData.vcu1d5h) {
                vcu1d5hTorqueCommandData.push({ x: dataTime, y: rutaxData.vcu1d5h.torqueCmd });
            }
            // BMS_1D9H
            if (rutaxData.bms1d9h) {
                bms1d9hDcLinkVoltageData.push({ x: dataTime, y: rutaxData.bms1d9h.dcLinkVolt });
                bms1d9hBatteryPackCurrentData.push({ x: dataTime, y: rutaxData.bms1d9h.batPackCurr });
            }
            // VCU_321H
            if (rutaxData.vcu321h) {
                vcu321hBatteryPackRsocData.push({ x: dataTime, y: rutaxData.vcu321h.batPackRSoc });
            }
            // VCU_323H
            if (rutaxData.vcu323h) {
                vcu323hBatteryMinTempData.push({ x: dataTime, y: rutaxData.vcu323h.batMinTemp });
                vcu323hBatteryMaxTempData.push({ x: dataTime, y: rutaxData.vcu323h.batMaxTemp });
            }
            // VCU_341H
            if (rutaxData.vcu341h) {
                vcu341hEvccPdStatData.push({ x: dataTime, y: rutaxData.vcu341h.pdStat });
            }
            // VCU_343H
            if (rutaxData.vcu343h) {
                vcu343hChgFinishedData.push({ x: dataTime, y: rutaxData.vcu343h.chgFinished });
            }
            // VCU_7E7H
            if (rutaxData.vcu7e7h) {
                vcu7e7hCurrSteerAngleData.push({ x: dataTime, y: rutaxData.vcu7e7h.currSteerAngle ?? 0 });
                vcu7e7hRightLampStatusData.push({ x: dataTime, y: rutaxData.vcu7e7h.rightLampStatus ?? 0 });
                vcu7e7hLeftLampStatusData.push({ x: dataTime, y: rutaxData.vcu7e7h.leftLampStatus ?? 0 });
                vcu7e7hHazardLampStatusData.push({ x: dataTime, y: rutaxData.vcu7e7h.hazardLampStatus ?? 0 });
                vcu7e7hEpbStatusData.push({ x: dataTime, y: rutaxData.vcu7e7h.epbStatus ?? 0 });
            }
            // VCU_7E8H
            if (rutaxData.vcu7e8h) {
                vcu7e8hBmsFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.bmsFail });
                vcu7e8hEpsFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.epsFail });
                vcu7e8hJoystickFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.joystickFail });
                vcu7e8hMcuFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.mcuFail });
                vcu7e8hEscFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.escFail });
                vcu7e8hAdsFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.adsFail });
                vcu7e8hBcuFailureData.push({ x: dataTime, y: rutaxData.vcu7e8h.bcuFail });
            }
            // ADS_1B1H
            if (rutaxData.ads1b1h) {
                ads1b1hTargetSpeedData.push({ x: dataTime, y: rutaxData.ads1b1h.targetSpeed });
                ads1b1hApsData.push({ x: dataTime, y: rutaxData.ads1b1h.aps });
                ads1b1hGearStatusCmdData.push({ x: dataTime, y: rutaxData.ads1b1h.gearStatusCmd });
                ads1b1hBrakingRequestData.push({ x: dataTime, y: rutaxData.ads1b1h.brakingReq });
                ads1b1hAliveCounterData.push({ x: dataTime, y: rutaxData.ads1b1h.aliveCounter });
            }
            // ADS_1B2H
            if (rutaxData.ads1b2h) {
                ads1b2hStatusData.push({ x: dataTime, y: rutaxData.ads1b2h.status });
                ads1b2hEpbRequestData.push({ x: dataTime, y: rutaxData.ads1b2h.epbReq });
                ads1b2hEmergencyStopData.push({ x: dataTime, y: rutaxData.ads1b2h.emergencyStopReq });
                ads1b2hSteerAngleData.push({ x: dataTime, y: rutaxData.ads1b2h.steerAngle });
                ads1b2hAliveCounterData.push({ x: dataTime, y: rutaxData.ads1b2h.aliveCounter });
            }
            // ADS_1B3H
            if (rutaxData.ads1b3h) {
                ads1b3hLampReqLhData.push({ x: dataTime, y: rutaxData.ads1b3h.lampReqLh });
                ads1b3hLampReqRhData.push({ x: dataTime, y: rutaxData.ads1b3h.lampReqRh });
                ads1b3hLampReqHazardData.push({ x: dataTime, y: rutaxData.ads1b3h.lampReqHazard });
            }
            // JOY_181H
            if (rutaxData.joy181h) {
                joy181hDesiredSteerAngleData.push({ x: dataTime, y: rutaxData.joy181h.desiredSteerAngle });
                joy181hEpbRequestData.push({ x: dataTime, y: rutaxData.joy181h.epbReq });
                joy181hHazardLampData.push({ x: dataTime, y: rutaxData.joy181h.hazardLamp });
                joy181hKeyoffData.push({ x: dataTime, y: rutaxData.joy181h.keyoff });
                joy181hCounterData.push({ x: dataTime, y: rutaxData.joy181h.aliveCounter });
            }
            // JOY_182H
            if (rutaxData.joy182h) {
                joy182hMcuRpmSetData.push({ x: dataTime, y: rutaxData.joy182h.mcuRpmSet });
                joy182hDirectionData.push({ x: dataTime, y: rutaxData.joy182h.direction });
                joy182hBrakingRequestData.push({ x: dataTime, y: rutaxData.joy182h.brakingReq });
                joy182hCounterData.push({ x: dataTime, y: rutaxData.joy182h.aliveCounter });
            }
        });

        // Set chart data using spread operator pattern (same as BukgiViewer/NavyaViewer)
        setChartEhbi080hSpeed((prev) => ({ ...prev, data: ehbi080hSpeedData }));
        setChartVcu090hBrakingRequest((prev) => ({ ...prev, data: vcu090hBrakingRequestData }));
        setChartVcu1d5hTorqueCmd((prev) => ({ ...prev, data: vcu1d5hTorqueCommandData }));
        setChartBms1d9hDcLinkVoltage((prev) => ({ ...prev, data: bms1d9hDcLinkVoltageData }));
        setChartBms1d9hBatteryPackCurrent((prev) => ({ ...prev, data: bms1d9hBatteryPackCurrentData }));
        setChartVcu321hBatteryPackRsoc((prev) => ({ ...prev, data: vcu321hBatteryPackRsocData }));
        setChartVcu323hBatteryMinTemp((prev) => ({ ...prev, data: vcu323hBatteryMinTempData }));
        setChartVcu323hBatteryMaxTemp((prev) => ({ ...prev, data: vcu323hBatteryMaxTempData }));
        setChartVcu341hEvccPdStat((prev) => ({ ...prev, data: vcu341hEvccPdStatData }));
        setChartVcu343hChgFinished((prev) => ({ ...prev, data: vcu343hChgFinishedData }));
        setChartVcu7e7hCurrSteerAngle((prev) => ({ ...prev, data: vcu7e7hCurrSteerAngleData }));
        setChartVcu7e7hRightLampStatus((prev) => ({ ...prev, data: vcu7e7hRightLampStatusData }));
        setChartVcu7e7hLeftLampStatus((prev) => ({ ...prev, data: vcu7e7hLeftLampStatusData }));
        setChartVcu7e7hHazardLampStatus((prev) => ({ ...prev, data: vcu7e7hHazardLampStatusData }));
        setChartVcu7e7hEpbStatus((prev) => ({ ...prev, data: vcu7e7hEpbStatusData }));
        setChartVcu7e8hBmsFailure((prev) => ({ ...prev, data: vcu7e8hBmsFailureData }));
        setChartVcu7e8hEpsFailure((prev) => ({ ...prev, data: vcu7e8hEpsFailureData }));
        setChartVcu7e8hJoystickFailure((prev) => ({ ...prev, data: vcu7e8hJoystickFailureData }));
        setChartVcu7e8hMcuFailure((prev) => ({ ...prev, data: vcu7e8hMcuFailureData }));
        setChartVcu7e8hEscFailure((prev) => ({ ...prev, data: vcu7e8hEscFailureData }));
        setChartVcu7e8hAdsFailure((prev) => ({ ...prev, data: vcu7e8hAdsFailureData }));
        setChartVcu7e8hBcuFailure((prev) => ({ ...prev, data: vcu7e8hBcuFailureData }));
        setChartAds1b1hTargetSpeed((prev) => ({ ...prev, data: ads1b1hTargetSpeedData }));
        setChartAds1b1hAps((prev) => ({ ...prev, data: ads1b1hApsData }));
        setChartAds1b1hGearStatusCmd((prev) => ({ ...prev, data: ads1b1hGearStatusCmdData }));
        setChartAds1b1hBrakingRequest((prev) => ({ ...prev, data: ads1b1hBrakingRequestData }));
        setChartAds1b1hAliveCounter((prev) => ({ ...prev, data: ads1b1hAliveCounterData }));
        setChartAds1b2hStatus((prev) => ({ ...prev, data: ads1b2hStatusData }));
        setChartAds1b2hEpbRequest((prev) => ({ ...prev, data: ads1b2hEpbRequestData }));
        setChartAds1b2hEmergencyStop((prev) => ({ ...prev, data: ads1b2hEmergencyStopData }));
        setChartAds1b2hSteerAngle((prev) => ({ ...prev, data: ads1b2hSteerAngleData }));
        setChartAds1b2hAliveCounter((prev) => ({ ...prev, data: ads1b2hAliveCounterData }));
        setChartAds1b3hLampReqLh((prev) => ({ ...prev, data: ads1b3hLampReqLhData }));
        setChartAds1b3hLampReqRh((prev) => ({ ...prev, data: ads1b3hLampReqRhData }));
        setChartAds1b3hLampReqHazard((prev) => ({ ...prev, data: ads1b3hLampReqHazardData }));
        setChartJoy181hDesiredSteerAngle((prev) => ({ ...prev, data: joy181hDesiredSteerAngleData }));
        setChartJoy181hEpbRequest((prev) => ({ ...prev, data: joy181hEpbRequestData }));
        setChartJoy181hHazardLamp((prev) => ({ ...prev, data: joy181hHazardLampData }));
        setChartJoy181hKeyoff((prev) => ({ ...prev, data: joy181hKeyoffData }));
        setChartJoy181hCounter((prev) => ({ ...prev, data: joy181hCounterData }));
        setChartJoy182hMcuRpmSet((prev) => ({ ...prev, data: joy182hMcuRpmSetData }));
        setChartJoy182hDirection((prev) => ({ ...prev, data: joy182hDirectionData }));
        setChartJoy182hBrakingRequest((prev) => ({ ...prev, data: joy182hBrakingRequestData }));
        setChartJoy182hCounter((prev) => ({ ...prev, data: joy182hCounterData }));

    }, [runningCanDataList]);

    useEffect(() => {
        if (runningCanDataList === undefined || selectedDataPointIndex === undefined) return;

        if (vehicleInfo?.makerModel?.maker?.makerName === Common.VehicleMaker.Emotion) {
            const canData = runningCanDataList[selectedDataPointIndex] as CanDataRutax.CanData;

            setCurrentCanData(canData);
        }
    }, [selectedDataPointIndex]);

    // Chart mounted callback - matches CanDataNavyaViewer pattern
    useEffect(() => {
        if (
            ehbi080hChartMounted === true ||
            vcu090hChartMounted === true ||
            vcu1d5hChartMounted === true ||
            bms1d9hChartMounted === true ||
            vcu321hChartMounted === true ||
            vcu323hChartMounted === true ||
            vcu341hChartMounted === true ||
            vcu343hChartMounted === true ||
            vcu7e7hChartMounted === true ||
            vcu7e8hChartMounted === true ||
            ads1b1hChartMounted === true ||
            ads1b2hChartMounted === true ||
            ads1b3hChartMounted === true ||
            joy181hChartMounted === true ||
            joy182hChartMounted === true
        ) {
            if (onMountedChart !== undefined) onMountedChart();
        }
    }, [
        ehbi080hChartMounted,
        vcu090hChartMounted,
        vcu1d5hChartMounted,
        bms1d9hChartMounted,
        vcu321hChartMounted,
        vcu323hChartMounted,
        vcu341hChartMounted,
        vcu343hChartMounted,
        vcu7e7hChartMounted,
        vcu7e8hChartMounted,
        ads1b1hChartMounted,
        ads1b2hChartMounted,
        ads1b3hChartMounted,
        joy181hChartMounted,
        joy182hChartMounted,
    ]);
    //#endregion

    const convertChartTooltip = (seriesName: string, value: number) => {
        let convertTooltipString = String(value);
        switch (seriesName) {
            case Common.RUTAX_EHBI080H_SPEED_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_SPEED);
                break;
            }

            case Common.RUTAX_VCU090H_BRAKING_REQ_NAME:
            case Common.RUTAX_VCU321H_BAT_PACK_RSOC_NAME:
            case Common.RUTAX_ADS1B1H_APS_NAME:
            case Common.RUTAX_ADS1B1H_BRAKING_REQ_NAME:
            case Common.RUTAX_JOY182H_BRAKING_REQ_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_PERCENT);
                break;
            }

            case Common.RUTAX_VCU1D5H_TORQUE_CMD_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_TORQUE);
                break;
            }

            case Common.RUTAX_BMS1D9H_DC_LINK_VOLT_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_VOLTAGE);
                break;
            }

            case Common.RUTAX_BMS1D9H_BAT_PACK_CURR_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_CURRENT);
                break;
            }

            case Common.RUTAX_VCU323H_BAT_MIN_TEMP_NAME:
            case Common.RUTAX_VCU323H_BAT_MAX_TEMP_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_CELSIUS);
                break;
            }

            case Common.RUTAX_VCU7E7H_CURR_STEER_ANGLE_NAME:
            case Common.RUTAX_ADS1B2H_STEER_ANGLE_NAME:
            case Common.RUTAX_JOY181H_DESIRED_STEER_ANGLE_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_DEGREE);
                break;
            }

            case Common.RUTAX_JOY182H_MCU_RPM_SET_NAME: {
                convertTooltipString = convertRemarkWithUnit(value, Common.UNIT_MOTOR_SPEED);
                break;
            }

            // On/Off 시그널
            case Common.RUTAX_VCU7E7H_RIGHT_LAMP_STATUS_NAME:
            case Common.RUTAX_VCU7E7H_LEFT_LAMP_STATUS_NAME:
            case Common.RUTAX_VCU7E7H_HAZARD_LAMP_STATUS_NAME:
            case Common.RUTAX_JOY181H_HAZARD_LAMP_NAME:
            case Common.RUTAX_JOY181H_KEYOFF_NAME: {
                convertTooltipString = convertRemarkOnOff(value);
                break;
            }

            // ADS_1B3H Lamp (Non-Active/Left/Right)
            case Common.RUTAX_ADS1B3H_LAMP_REQ_LH_NAME:
            case Common.RUTAX_ADS1B3H_LAMP_REQ_RH_NAME: {
                convertTooltipString = convertAds1b3hLampReqRemark(value);
                break;
            }

            // Non-Active/Active
            case Common.RUTAX_ADS1B3H_LAMP_REQ_HAZARD_NAME:
            case Common.RUTAX_ADS1B2H_EMERGENCY_STOP_REQ_NAME: {
                convertTooltipString = convertRemarkNonActiveActive(value);
                break;
            }

            // EPB 상태 (Released/Locked)
            case Common.RUTAX_VCU7E7H_EPB_STATUS_NAME: {
                convertTooltipString = convertRemarkEpbStatus(value);
                break;
            }

            // 정상/고장 시그널 (VCU_7E8H DTC)
            case Common.RUTAX_VCU7E8H_BMS_FAIL_NAME:
            case Common.RUTAX_VCU7E8H_EPS_FAIL_NAME:
            case Common.RUTAX_VCU7E8H_JOYSTICK_FAIL_NAME:
            case Common.RUTAX_VCU7E8H_MCU_FAIL_NAME:
            case Common.RUTAX_VCU7E8H_ESC_FAIL_NAME:
            case Common.RUTAX_VCU7E8H_ADS_FAIL_NAME:
            case Common.RUTAX_VCU7E8H_BCU_FAIL_NAME: {
                convertTooltipString = convertRemarkFailure(value);
                break;
            }

            // JOY_181H EPB Request (No/Unlock/Lock/Reserved)
            case Common.RUTAX_JOY181H_EPB_REQ_NAME: {
                convertTooltipString = convertRemarkJoyEpbRequest(value);
                break;
            }
        }
        return convertTooltipString;
    };

    const onChangeZoom = (zoom: any) => {
        onZoomed && onZoomed(zoom);
    };

    return (
        <div>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <div>
                    {/* EHBI_080H */}
                    <CanDataWrapper
                        title="EHBi_080h"
                        id="rutax-ehbi"
                        panelOpen={ehbi080hPanelOpen}
                        onChangePanelOpen={setEhbi080hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataEhbi080h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedEhbi080h}
                        onChangeTableSelect={onChangeEhbi080h}
                        tableGetTooltips={getTableTooltipEhbi080h}
                        seriesChartDatas={seriesChartDatasEhbi080h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setEhbi080hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_090H */}
                    <CanDataWrapper
                        title="VCU_090h"
                        id="rutax-vcu-brake"
                        panelOpen={vcu090hPanelOpen}
                        onChangePanelOpen={setVcu090hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu090h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu090h}
                        onChangeTableSelect={onChangeVcu090h}
                        tableGetTooltips={getTableTooltipVcu090h}
                        seriesChartDatas={seriesChartDatasVcu090h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu090hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_1D5H */}
                    <CanDataWrapper
                        title="VCU_1D5h"
                        id="rutax-vcu-torque"
                        panelOpen={vcu1d5hPanelOpen}
                        onChangePanelOpen={setVcu1d5hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu1d5h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu1d5h}
                        onChangeTableSelect={onChangeVcu1d5h}
                        tableGetTooltips={getTableTooltipVcu1d5h}
                        seriesChartDatas={seriesChartDatasVcu1d5h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu1d5hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* BMS_1D9H */}
                    <CanDataWrapper
                        title="BMS_1D9h"
                        id="rutax-bms1d9h"
                        panelOpen={bms1d9hPanelOpen}
                        onChangePanelOpen={setBms1d9hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataBms1d9h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedBms1d9h}
                        onChangeTableSelect={onChangeBms1d9h}
                        tableGetTooltips={getTableTooltipBms1d9h}
                        seriesChartDatas={seriesChartDatasBms1d9h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setBms1d9hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_321H */}
                    <CanDataWrapper
                        title="VCU_321h"
                        id="rutax-vcu321h"
                        panelOpen={vcu321hPanelOpen}
                        onChangePanelOpen={setVcu321hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu321h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu321h}
                        onChangeTableSelect={onChangeVcu321h}
                        tableGetTooltips={getTableTooltipVcu321h}
                        seriesChartDatas={seriesChartDatasVcu321h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu321hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_323H */}
                    <CanDataWrapper
                        title="VCU_323h"
                        id="rutax-vcu323h"
                        panelOpen={vcu323hPanelOpen}
                        onChangePanelOpen={setVcu323hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu323h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu323h}
                        onChangeTableSelect={onChangeVcu323h}
                        tableGetTooltips={getTableTooltipVcu323h}
                        seriesChartDatas={seriesChartDatasVcu323h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu323hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_341H */}
                    <CanDataWrapper
                        title="VCU_341h"
                        id="rutax-vcu341h"
                        panelOpen={vcu341hPanelOpen}
                        onChangePanelOpen={setVcu341hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu341h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu341h}
                        onChangeTableSelect={onChangeVcu341h}
                        tableGetTooltips={getTableTooltipVcu341h}
                        seriesChartDatas={seriesChartDatasVcu341h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu341hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_343H */}
                    <CanDataWrapper
                        title="VCU_343h"
                        id="rutax-vcu343h"
                        panelOpen={vcu343hPanelOpen}
                        onChangePanelOpen={setVcu343hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu343h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu343h}
                        onChangeTableSelect={onChangeVcu343h}
                        tableGetTooltips={getTableTooltipVcu343h}
                        seriesChartDatas={seriesChartDatasVcu343h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu343hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_7E7H */}
                    <CanDataWrapper
                        title="VCU_7E7h"
                        id="rutax-vcu-status"
                        panelOpen={vcu7e7hPanelOpen}
                        onChangePanelOpen={setVcu7e7hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu7e7h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu7e7h}
                        onChangeTableSelect={onChangeVcu7e7h}
                        tableGetTooltips={getTableTooltipVcu7e7h}
                        seriesChartDatas={seriesChartDatasVcu7e7h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu7e7hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* VCU_7E8H */}
                    <CanDataWrapper
                        title="VCU_7E8h"
                        id="rutax-vcu-dtc"
                        panelOpen={vcu7e8hPanelOpen}
                        onChangePanelOpen={setVcu7e8hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataVcu7e8h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedVcu7e8h}
                        onChangeTableSelect={onChangeVcu7e8h}
                        tableGetTooltips={getTableTooltipVcu7e8h}
                        seriesChartDatas={seriesChartDatasVcu7e8h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setVcu7e8hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* ADS_1B1H */}
                    <CanDataWrapper
                        title="ADS_1B1h"
                        id="rutax-ads1"
                        panelOpen={ads1b1hPanelOpen}
                        onChangePanelOpen={setAds1b1hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataAds1b1h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedAds1b1h}
                        onChangeTableSelect={onChangeAds1b1h}
                        tableGetTooltips={getTableTooltipAds1b1h}
                        seriesChartDatas={seriesChartDatasAds1b1h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setAds1b1hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* ADS_1B2H */}
                    <CanDataWrapper
                        title="ADS_1B2h"
                        id="rutax-ads2"
                        panelOpen={ads1b2hPanelOpen}
                        onChangePanelOpen={setAds1b2hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataAds1b2h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedAds1b2h}
                        onChangeTableSelect={onChangeAds1b2h}
                        tableGetTooltips={getTableTooltipAds1b2h}
                        seriesChartDatas={seriesChartDatasAds1b2h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setAds1b2hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* ADS_1B3H */}
                    <CanDataWrapper
                        title="ADS_1B3h"
                        id="rutax-ads3"
                        panelOpen={ads1b3hPanelOpen}
                        onChangePanelOpen={setAds1b3hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataAds1b3h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedAds1b3h}
                        onChangeTableSelect={onChangeAds1b3h}
                        tableGetTooltips={getTableTooltipAds1b3h}
                        seriesChartDatas={seriesChartDatasAds1b3h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setAds1b3hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* JOY_181H */}
                    <CanDataWrapper
                        title="JOY_181h"
                        id="rutax-joy1"
                        panelOpen={joy181hPanelOpen}
                        onChangePanelOpen={setJoy181hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataJoy181h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedJoy181h}
                        onChangeTableSelect={onChangeJoy181h}
                        tableGetTooltips={getTableTooltipJoy181h}
                        seriesChartDatas={seriesChartDatasJoy181h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setJoy181hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />

                    {/* JOY_182H */}
                    <CanDataWrapper
                        title="JOY_182h"
                        id="rutax-joy2"
                        panelOpen={joy182hPanelOpen}
                        onChangePanelOpen={setJoy182hPanelOpen}
                        dataLoading={loading}
                        tableDataSource={tableDataJoy182h}
                        noFileteredCount={noFileteredCount}
                        tableSelectRowKeys={selectedJoy182h}
                        onChangeTableSelect={onChangeJoy182h}
                        tableGetTooltips={getTableTooltipJoy182h}
                        seriesChartDatas={seriesChartDatasJoy182h}
                        convertChartTooltips={convertChartTooltip}
                        selectedChartDataPointIndex={selectedDataPointIndex}
                        onChangedSelectChartDataPointIndex={onChangedSelectDataPointIndex}
                        onMountedChart={() => setJoy182hChartMounted(true)}
                        onZoomed={onChangeZoom}
                    />
                </div>
            </Space>
        </div>
    );
}

export default CanDataRutaxViewer;
